module.exports = __webpack_public_path__ + "static/media/save_the_bees_article.2addf362.jpg";